import { t } from '@lingui/core/macro';
import { useMemo } from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/Form/pickers';

import type { RuleBuilderDateRangeType } from './types';

type Props = {
  value?: RuleBuilderDateRangeType | undefined;
  onBlur?: () => void;
  onChange?: (value: RuleBuilderDateRangeType) => void;
  disabled?: boolean;
};

const RuleBuilderDateRange = ({
  value = { unit: 'day', count: 90 },
  onBlur,
  onChange,
  disabled = false,
}: Props) => {
  const dateRangeOptions = useMemo(
    () => [
      { label: t`Last 7 days`, value: '7day' },
      { label: t`Last 14 days`, value: '14day' },
      { label: t`Last 30 days`, value: '30day' },
      { label: t`Last 60 days`, value: '60day' },
      { label: t`Last 90 days`, value: '90day' },
      { label: t`Last 180 days`, value: '180day' },
      { label: t`Last 365 days`, value: '365day' },
    ],
    [],
  );

  return (
    <Select
      items={dateRangeOptions}
      value={`${value.count}${value.unit}`}
      onValueChange={(val) => {
        onChange?.({
          unit: 'day',
          count: Number((val ?? '7day').replace('day', '')),
        });
      }}
      disabled={disabled}
    >
      <SelectTrigger className="w-45" onBlur={onBlur}>
        <SelectValue placeholder={t`Select a date range...`} />
      </SelectTrigger>
      <SelectContent>
        {dateRangeOptions.map((item) => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default RuleBuilderDateRange;
